import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderService } from '../header.service';
import RoutesserviceService from '../routesservice.service';

@Injectable({
  providedIn: 'root',
})
export class NotesService {
  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService
  ) { }

  async getNotes() {
    //alert('inpolicy');
    return this.httpClient
      .post(this.Customeroutes.getAllNotes(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
      });
  }

  async getNotesFilter(date: any, month: any, year: any) {
    //alert('inpolicy');
    const formData = {
      date: date || '',
      month: month || '',
      year: year || '',
    };
    return this.httpClient
      .post(this.Customeroutes.getNotesFilters(), formData, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
      });
  }
}


